<template>
  <div id="app-related">
    <h3>相关项目</h3>
    <div class="related-box" v-for="(item,index) in relateData" :key="index">
      <router-link :to="{ name: 'projectDetails', query: { id: item.id }}" >
        <i>
          <img v-lazy="item.paper_pic_url" alt>
        </i>
        <div class="content-box">
          <h5>{{item.project_name}}</h5>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    relateData:{}
  },
  data() {
    
    return {
      // relateData: [
        // {
        //   title: "被遗弃半个世纪麻风病白内障患者走上复明路",
        //   amount:'5,000,000'
        // },
        // {
        //   title: "被遗弃半个世纪麻风病白内障患者走上复明路",
        //   amount:'5,000,000'
        // },
        // {
        //   title: "被遗弃半个世纪麻风病白内障患者走上复明路",
        //   amount:'5,000,000'
        // },
      // ]
    };
  }
};
</script>

<style lang="scss" scoped>
#app-related {
  width: 100%;
  border: solid 1px #eaeaea;
  margin-top: 20px;
  > h3 {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    border-bottom: solid 1px #eaeaea;
    padding: 20px 0;
    padding-left: 20px;
    margin-bottom: 42px;
  }
}
.related-box {
  margin: 0 24px 20px 16px;
  padding-left: 100px;
  position: relative;
  > a {
    > i {
    width: 100px;
    height: 86px;
    position: absolute;
    top: 0;
    left: 0;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  .content-box {
    margin-left: 14px;
    height: 86px;
    position: relative;
    > h5 {
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      margin-top: 3px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    > p {
      font-size: 14px;
      color: #999999;
      position: absolute;
      left: 0;
      bottom: 1px;
      > span {
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #c30d23;
      }
    }
  }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_related.vue